const ComboService = (function () {

    'use strict';

    let chosenItems = new Map();
    let countOfSteps;
    let comboId;
    let comboPrice;

    let currentStep = 1;
    let currentClickStep = 1;

    let scrollOffset = 0;
    let scrollOffsetMap = new Map()

    //вертикальный скрол
    let lastScroll = 0;
    let scrollMain = 0;
    let scrollLimit;

    let isNotProcess = true;

    let calculationMethod;
    let isFinishBtnActive = false;

    //Основные элементы управления модалкой
    // Открытие модального окна сборки комбо
    const openComboConstructor = () => {
        $('.js-combo-constructor').click(function () {
            chosenItems.clear();

            comboId = $(this).data('combo-id');

            getComboAndBuild(comboId);

            $('#comboConstructorModal').modal('show');
        });
    };

    // Очищение комбо при нажатии на крест или область вне модального окна
    const closeComboConstructor = () => {
        $('#comboConstructorModal').on('hidden.bs.modal', function () {
            close()
        });
    };

    function close() {
        chosenItems.clear();
        comboId = "";


        currentStep = 1;
        currentClickStep = 1;
        scrollOffset = 0;
        scrollOffsetMap.clear();

        hideFinishBtn();

        removeActiveListeners();
    }


    function getComboAndBuild(comboId) {
        $.ajax({
            url: '/combo/get/' + comboId,
            method: 'GET'
        }).done(({result}) => {
            startConstructor(result)
        });
    }

    function startConstructor(result) {

        countOfSteps = result.countOfSteps;
        comboPrice = result.price;
        comboId = result.comboId;
        calculationMethod = result.calculationMethod;

        ComboConstructorService.constructCombo(result);

        addListenersGeneratedNodes();

        preset();

        showItemsForActiveStep();
    }

    //Добавление слушателей для созданных js'ом node
    function addListenersGeneratedNodes() {
        $(".js-combo-constructor-step").click(stepClick);

        $('.js-show-full-info').click(showFullInfo);

        $('.js-choose-item-on-current-step').click(chooseItem);
    }

    //удаление слушателей созданных в процессе генерации node'ы
    function removeActiveListeners() {
        $(".js-combo-constructor-step").unbind("click", stepClick);

        $('.js-show-full-info').unbind("click", showFullInfo);

        $('.js-choose-item-on-current-step').unbind("click", chooseItem);
    }

    //Добовление слушателей на базовые элементы
    function addListenersToSolidNode() {
        $('.js-combo-constructor-add-to-basket').click(addToCart);

        $('#comboConstructorModal').scroll(verticalMainScroll);

        $('.combo_items-body').scroll(verticalChildScroll);
    }

    //Возвращение начального состояния окна
    function preset() {
        $(".js-combo-constructor-steps").animate({scrollLeft: 0}, 700);

        isNotProcess = true

        scrollLimit = $(".js-combo-constructor-title").height() + $('.js-combo-constructor-description').height() + 32;
    }


    //listeners
    function stepClick(event) {
        if (!$(this).hasClass("steps-step--active")) {
            if (isCanChangeStep($(this))) {
                setStep($(this));
            }
        }
    }

    function showFullInfo(event) {
        const _id = $(this).attr('id').replace("btn-", '')

        if ($(this).hasClass("item-info_btn--active")) {
            $(this).removeClass('item-info_btn--active');
            $("#info-" + _id).removeClass('item-full_info--active').hide("fade", 200);
        } else {
            //скрыть старые
            $('.item-info_btn--active').removeClass('item-info_btn--active');
            $('.item-full_info--active').removeClass('item-full_info--active').hide("fade", 200);

            //активировать новое инфо
            $(this).addClass('item-info_btn--active');
            $("#info-" + _id).addClass('item-full_info--active').show("fade", 300);
        }
    }

    function chooseItem(event) {
        if ($(this).hasClass("item-btn--active")) {
            removeItem($(this));
        } else {
            removeAllOnStep($(this).data('step'));
            addItem($(this));
        }

        const finalElement = chosenItems.size == countOfSteps;
        if (calculationMethod === "MODIFICATORS_PRICE") {
            comboPrice = 0;
            chosenItems.forEach((itemArray) => {
                itemArray.forEach((item) => {
                    comboPrice += item.price * 100;
                });
            });
        }

        let needShowFinishBtn = false;
        if (calculationMethod === "MODIFICATORS_PRICE") {
            needShowFinishBtn = chosenItems.size > 0;
        } else {
            needShowFinishBtn = finalElement;
        }

        if (needShowFinishBtn) {
            showFinishBtn();
        } else {
            hideFinishBtn();
        }

        if (finalElement) {
            makeFinishBtnAvailable();
        } else {
            makeFinishBtnDisable();
        }
    }

    function verticalMainScroll(event) {
        scrollMain = $(this).scrollTop();
    }

    function verticalChildScroll(event) {
        var st = $(this).scrollTop();
        const scrollDelta = lastScroll - st;

        scrollMain -= (scrollDelta / 1.5);
        if (scrollMain > scrollLimit)
            scrollMain = scrollLimit;
        if (scrollMain < 0)
            scrollMain = 0;

        $('#comboConstructorModal').scrollTop(scrollMain);

        if (st > lastScroll) {
        } else {
        }
        lastScroll = st;

        if (st > 10) {
            $(".js-shadow-mobile-header").show("fade", 600);
        } else {
            $(".js-shadow-mobile-header").hide();
        }
    }


    //actions
    function setStep(element) {
        setStepPassed();
        setActiveElement(element);
        showItemsForActiveStep();

        currentClickStep = element.data('step');
    }

    function setStepPassed() {
        $(".steps-step--active").addClass("steps-step--passed");
        $(".steps-step--active").removeClass("steps-step--active");
    }

    function isCanChangeStep(nextStepElement) {
        const newStep = nextStepElement.data("step");

        if (currentClickStep > newStep)
            return true;
        else if (newStep <= getLastNotChosenStep())
            if (chosenItems.get(currentClickStep))
                return true;

        return false;
    }

    function setActiveElement(element) {
        element.addClass("steps-step--active");
        element.removeClass("steps-step--passed");
    }

    function showItemsForActiveStep() {
        if (isUnsupportedBrowser()) {
            $(".js-combo-constructor-item").hide();

        } else {
            $(".js-combo-constructor-item").hide("drop", {direction: "left"}, 300);
        }

        const activeStep = $(".steps-step--active").data('step');

        if (isUnsupportedBrowser()) {
            $('.js-combo-tem-step-' + activeStep).show();
            setTimeout(() => {
                $('.js-combo-tem-step-' + activeStep).css("display", "inline-block")
            }, 100);
        } else {
            $('.js-combo-tem-step-' + activeStep).delay(300).show("drop", {direction: "right"}, 600, () => {
                $(this).css("display", "inline-block")
            });
        }
    }

    // tag::Определение браузера[]

    function isUnsupportedBrowser() {
        const isMozilla = getBrowser() === "Mozilla";
        const isSafari = getBrowser() === "Safari";

        return isMozilla || isSafari;
    }

    function getBrowser () {
        return searchString(dataBrowser) || "An unknown browser";
    }

    function searchString (data) {
        for (let i = 0; i < data.length; i++) {
            const dataString = data[i].string;
            const dataProp = data[i].prop;
            if (dataString) {
                if (dataString.indexOf(data[i].subString) != -1)
                    return data[i].identity;
            } else if (dataProp)
                return data[i].identity;
        }
    }

    const dataBrowser = [
        {
            string: navigator.userAgent,
            subString: "Chrome",
            identity: "Chrome"
        },
        {
            string: navigator.vendor,
            subString: "Apple",
            identity: "Safari",
            versionSearch: "Version"
        },
        {
            prop: window.opera,
            identity: "Opera",
            versionSearch: "Version"
        },
        {
            string: navigator.userAgent,
            subString: "Firefox",
            identity: "Firefox"
        },
        {
            string: navigator.userAgent,
            subString: "MSIE",
            identity: "Internet Explorer",
            versionSearch: "MSIE"
        },
        {
            string: navigator.userAgent,
            subString: "Gecko",
            identity: "Mozilla",
            versionSearch: "rv"
        }];

    // end::Определение браузера[]

    function addItem(element) {
        element.addClass('item-btn--active');
        element.text('уже в комбо');

        addComboItem(
            element.data('step'),
            element.data('item'),
            element.data('picture'),
            element.data('ingredient'),
            element.data('title'),
            element.data('description'),
            element.data('price')
        );

        if (element.data('step') == currentStep) {
            addScrollOffset(currentStep);
            currentStep++;
        }

        const autoStep = chosenItems.size != countOfSteps;
        if (autoStep) {
            setStep($("#step-" + getLastNotChosenStep()));
            scrollStep(getLastNotChosenStep() - 1);
        }
    }

    function addScrollOffset(step) {
        scrollOffset += ($("#step-" + currentStep).width() + 16);

        if (scrollOffsetMap.get(step) !== undefined) {
            scrollOffsetMap.delete(step);
        }
        scrollOffsetMap.set(step, scrollOffset);
    }

    function scrollStep(step) {
        $(".js-combo-constructor-steps").animate({scrollLeft: scrollOffsetMap.get(step)}, 700);
    }

    function removeAllOnStep(step) {
        $('.js-btn-on-step-' + step).each((i, j) => removeItem($(j), step));
    }

    function removeItem(element) {
        element.text('выбрать');
        element.removeClass('item-btn--active');

        removeComboItem(element.data('step'))
    }

    function removeComboItem(step) {
        chosenItems.delete(step);
    }

    function addComboItem(step, item, picture, ingredient, title, description, price) {
        var chosenItem = {
            itemGroupId: item,
            itemId: ingredient,
            pictureId: picture,
            title: title,
            description: description,
            price: price
        };
        if (chosenItems.get(step) !== undefined) {
            chosenItems.delete(step);
        }
        chosenItems.set(step, new Array(chosenItem));
    }

    function showFinishBtn() {
        $('.js-finish-price').text(fromPennyToRuble(comboPrice) + ' ₽');
        $('.js-finish-btn').show();
    }

    function hideFinishBtn() {
        $('.js-finish-btn').hide();
    }

    function makeFinishBtnDisable() {
        isFinishBtnActive = false;
        $(".js-combo-constructor-add-to-basket").addClass("combo_items-finish_btn--disabled");
    }

    function makeFinishBtnAvailable() {
        isFinishBtnActive = true;
        $(".js-combo-constructor-add-to-basket").removeClass("combo_items-finish_btn--disabled");
    }

    function addToCart() {
        if (isNotProcess && isFinishBtnActive) {
            isNotProcess = false;
            let comboParts = {};
            for (var [key, value] of chosenItems) {
                var comboArr = [];
                var comboItem = {
                    itemGroupId: value[0].itemGroupId,
                    itemDocId: value[0].itemId,
                    count: 1
                };
                comboArr.push(comboItem);
                comboParts[key] = comboArr;
            }

            let data = {
                comboId: comboId,
                count: 1,
                price: comboPrice,
                chosenItems: comboParts
            };

            $.ajax({
                url: '/cart/add/combo',
                method: 'POST',
                contentType: "application/json",
                data: JSON.stringify(data)
            }).done(({result}) => {
                BasketService.updateBasketInfo(
                    result.count,
                    result.price,
                    result.maxFreeItems,
                    result.standardFreeItems,
                    result.itemsWithIds,
                    result.countPositions
                );
                AnimationsService.animate.basket();
                $('#comboConstructorModal').modal('hide');
            });
        }
    }

    //utils

    function fromPennyToRuble(price) {
        return price / 100;
    }

    function getLastNotChosenStep() {
        for (let i = 1; i <= countOfSteps; i++)
            if (chosenItems.get(i) == undefined)
                return i;

        return countOfSteps;
    }

    // Изменение кол-ва комбо товара в корзине
    const changeComboCountInTheBasket = (id, count, idInBasket) => {
        $.ajax({
            url: 'cart/combo/change-count/' + id + '/' + idInBasket + '/' + count,
            method: 'POST',
            contentType: 'application/json',
        }).done(response => {
            if (response.code === "200") {
                BasketService.updateBasketInfo(
                    response.result.count,
                    response.result.price,
                    response.result.maxFreeItems,
                    response.result.standardFreeItems,
                    response.result.itemsWithIds,
                    response.result.countPositions
                );
            }
        })
    };

    function CreateInOrderCombo() {

        //************ Variables ************/
        var element = {};
        var id = "";
        var idInBasket = "";
        var count = 0;
        var price = 0;
        var freePrice = 0;
        var maxFreeCount = 0;

        //************ Functions ************//
        function setId(value) {
            id = value;
        }

        function getId() {
            return id;
        }

        function setIdInBasket(value) {
            idInBasket = value;
        }

        function getIdInBasket() {
            return idInBasket;
        }

        function setElement(value) {
            element = value;
            count = parseInt(element.find('.js-cart-combo-count').text());
            price = parseFloat(element.find('.js-cart-combo-price').text());
            freePrice = parseFloat(element.find('.js-cart-combo-price').data('price'));
            maxFreeCount = parseInt(element.find('.js-cart-combo-count').data('max-free-count'));
        }

        function getElement() {
            return element;
        }

        function setCount(value) {
            count = value;
            element.find('.js-cart-combo-count').text(count);
            if (value > 0) {
                element.show();
            } else {
                element.hide();
            }
        }

        function getCount() {
            return count;
        }

        function setMaxFreeCount(value) {
            maxFreeCount = value;
            updateTotalPrice();
        }

        function updateTotalPrice() {
            element.find('.js-cart-combo-total-price').text(getTotalPrice());
        }

        function getTotalPrice() {
            return count * price;
        }

        function inc() {
            setCount(count + 1);
            updateTotalPrice();
            changeComboCountInTheBasket(id, count, idInBasket);
        }

        function dec() {
            if (count === 1) {
                remove();
                return;
            }
            setCount(count - 1);
            updateTotalPrice();
            changeComboCountInTheBasket(id, count, idInBasket);
        }

        function remove() {
            setCount(0);
            changeComboCountInTheBasket(id, 0, idInBasket);
        }

        //************ Public ************//
        return {
            setId: setId,
            getId: getId,
            setIdInBasket: setIdInBasket,
            getIdInBasket: getIdInBasket,
            setMaxFreeCount: setMaxFreeCount,
            setCount: setCount,
            getCount: getCount,
            setElement: setElement,
            getElement: getElement,
            inc: inc,
            dec: dec,
            remove: remove
        };
    }

    function init() {
        openComboConstructor();
        closeComboConstructor();
        addListenersToSolidNode();

        $('.js-cart-combo').filter(function () {
            var element = $(this);
            var id = element.data('id');
            var count = parseInt(element.find('.js-cart-combo-count').text());
            var idInBasket = element.data('particular-combo-id-in-basket');
            var inOrderCombo = CreateInOrderCombo();
            inOrderCombo.setElement(element);
            inOrderCombo.setId(id);
            inOrderCombo.setCount(count);
            inOrderCombo.setIdInBasket(idInBasket);

            element.find('.js-cart-combo-delete').click(function () {
                inOrderCombo.remove();
            });
            element.find('.js-cart-combo-inc').click(function () {
                inOrderCombo.inc();
            });
            element.find('.js-cart-combo-dec').click(function () {
                inOrderCombo.dec();
            });


        });
    }

    //************ Public ************//
    return {
        init: init,
    };
})
();
$(ComboService.init);